/* tslint:disable */
/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType } from 'graphql';
/**
 * This file is auto-generated by graphql-schema-typescript
 * Please note that any changes in this file may be overwritten
 */
 

/*******************************
 *                             *
 *          TYPE DEFS          *
 *                             *
 *******************************/
export interface GQLAcceptInvitationInput {
  hash: string;
  password?: string;
  passwordRepeat?: string;
  firstName?: string;
  lastName?: string;
}

export enum GQLAccessLevelEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface GQLActivity {
  id: string;
  type: GQLActivityTypeEnum;
  author: GQLProfile;
  project: GQLProject;
  thread?: GQLThread;
  message?: GQLMessage;
  file?: GQLFile;
  fileVersion?: GQLFileVersion;
  comment?: GQLComment;
  createdAt: GQLDateTime;
  isViewed: boolean;
}

export interface GQLActivityList {
  total: number;
  skip: number;
  limit: number;
  unread: number;
  items: Array<GQLActivity>;
}

export enum GQLActivityTypeEnum {
  THREAD_CREATED = 'THREAD_CREATED',
  THREAD_APPROVED = 'THREAD_APPROVED',
  MESSAGE_CREATED = 'MESSAGE_CREATED',
  FILE_CREATED = 'FILE_CREATED',
  FILE_UPDATED = 'FILE_UPDATED',
  FILE_COMMENTED = 'FILE_COMMENTED',
  FILE_APPROVED = 'FILE_APPROVED',
  PROJECT_MEMBERS_ADDED = 'PROJECT_MEMBERS_ADDED',
  PROJECT_MEMBERS_REMOVED = 'PROJECT_MEMBERS_REMOVED'
}

export interface GQLAddCompanyProfileInput {
  companyId: string;
  profileId: string;
}

export interface GQLAddCompanyProfilePayload {
  company: GQLCompany;
}

export interface GQLAddCompanyToProjectInput {
  id: string;
  companyId: string;
}

export interface GQLAddCompanyToProjectPayload {
  project: GQLProject;
}

export interface GQLApproveFileVersionInput {
  id: string;
}

export interface GQLApproveFileVersionPayload {
  fileVersion: GQLFileVersion;
}

export interface GQLApproveThreadInput {
  id: string;
}

export interface GQLApproveThreadPayload {
  thread: GQLThread;
}

export interface GQLAttachmentInput {
  useTools: boolean;
  file: GQLFileUpload;
  type?: GQLFileTypeEnum;
}

export interface GQLClearActivitiesPayload {
  activities: Array<GQLActivity>;
}

export interface GQLComment {
  id: string;
  body: string;
  author: GQLProfile;
  marker: GQLMarker;
  isViewed: boolean;
  isEdited: boolean;
  canEdit: boolean;
  canRemove: boolean;
  createdAt: GQLDateTime;
  updatedAt: GQLDateTime;
}

export interface GQLCompany {
  id: string;
  name: string;
  profiles?: GQLProfileList;
}

export interface GQLCompanyList {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLCompany>;
}

export interface GQLCountry {
  code: string;
  name: string;
}

export interface GQLCreateCommentInput {
  markerId: string;
  body: string;
  link?: string;
}

export interface GQLCreateCommentPayload {
  comment: GQLComment;
}

export interface GQLCreateCompanyInput {
  name: string;
}

export interface GQLCreateCompanyPayload {
  company: GQLCompany;
}

export interface GQLCreateFileInput {
  projectId: string;
  threadId?: string;
  attachments: Array<GQLAttachmentInput>;
}

export interface GQLCreateFilePayload {
  files: Array<GQLFile>;
}

export interface GQLCreateFileVersionInput {
  id: string;
  file: GQLFileUpload;
}

export interface GQLCreateFileVersionPayload {
  fileVersion: GQLFileVersion;
}

export interface GQLCreateInvitationInput {
  email: string;
  role: GQLRolesEnum;
  acceptLink: string;
  projectIds?: Array<string>;
}

export interface GQLCreateInvitationPayload {
  invitation: GQLInvitation;
}

export interface GQLCreateMarkerGroupInput {
  versionId: string;
  imageSrc?: string;
  configuration?: string;
}

export interface GQLCreateMarkerGroupPayload {
  markerGroup: GQLMarkerGroup;
}

export interface GQLCreateMarkerInput {
  versionId: string;
  groupId?: string;
  coordinates: string;
  comment: string;
  link?: string;
}

export interface GQLCreateMarkerPayload {
  marker: GQLMarker;
}

export interface GQLCreateMessageInput {
  threadId: string;
  parentId?: string;
  body: string;
  attachments?: Array<GQLAttachmentInput>;
  emailNotification?: GQLMessageEmailNotificationInput;
}

export interface GQLCreateMessagePayload {
  message: GQLMessage;
}

export interface GQLCreateProjectInput {
  title: string;
  logo?: GQLFileUpload;
  description?: string;
  members?: Array<string>;
  invitations?: Array<GQLProjectInvitationInput>;
  startDate?: GQLDateTime;
  expirationDate?: GQLDateTime;
}

export interface GQLCreateProjectPayload {
  project: GQLProject;
}

export interface GQLCreateResetPasswordRequestInput {
  email: string;
  resetLink: string;
}

export interface GQLCreateResetPasswordRequestPayload {
  success: boolean;
}

export interface GQLCreateThreadInput {
  projectId: string;
  title: string;
  body?: string;
  accessLevel: GQLAccessLevelEnum;
  contributors?: Array<string>;
  attachments?: Array<GQLAttachmentInput>;
}

export interface GQLCreateThreadPayload {
  thread: GQLThread;
}

export interface GQLDateRange {
  from?: GQLDateTime;
  to?: GQLDateTime;
}

export type GQLDateTime = any;

export interface GQLDisapproveFileVersionInput {
  id: string;
}

export interface GQLDisapproveFileVersionPayload {
  fileVersion: GQLFileVersion;
}

export interface GQLDisapproveThreadInput {
  id: string;
}

export interface GQLDisapproveThreadPayload {
  thread: GQLThread;
}

export interface GQLEditCommentInput {
  id: string;
  body: string;
}

export interface GQLEditCommentPayload {
  comment: GQLComment;
}

export interface GQLEditCompanyInput {
  id: string;
  name: string;
}

export interface GQLEditCompanyPayload {
  company: GQLCompany;
}

export interface GQLEditMessageInput {
  id: string;
  body: string;
  attachments?: Array<GQLAttachmentInput>;
  removedFiles?: Array<string>;
}

export interface GQLEditMessagePayload {
  message: GQLMessage;
}

export interface GQLEditNotificationSettingsInput {
  isEnabled: boolean;
  onThreadCreate: GQLNotificationSettingInput;
  onThreadApprove: GQLNotificationSettingInput;
  onMessageCreate: GQLNotificationSettingInput;
  onFileUpdate: GQLNotificationSettingInput;
  onFileComment: GQLNotificationSettingInput;
  onFileApprove: GQLNotificationSettingInput;
}

export interface GQLEditNotificationSettingsPayload {
  me: GQLMe;
}

export interface GQLEditProfileInput {
  id: string;
  role?: GQLRolesEnum;
  firstName?: string;
  lastName?: string;
  countryCode?: string;
  state?: string;
  city?: string;
  timezoneId?: string;
  avatar?: GQLFileUpload;
}

export interface GQLEditProfilePayload {
  profile: GQLProfile;
}

export interface GQLEditProjectInput {
  id: string;
  title?: string;
  logo?: GQLFileUpload;
  description?: string;
  members?: Array<string>;
  invitations?: Array<GQLProjectInvitationInput>;
  removedInvitations?: Array<string>;
  startDate?: GQLDateTime;
  expirationDate?: GQLDateTime;
}

export interface GQLEditProjectPayload {
  project: GQLProject;
}

export interface GQLEditThreadInput {
  id: string;
  title: string;
  body?: string;
  accessLevel: GQLAccessLevelEnum;
  contributors?: Array<string>;
  attachments?: Array<GQLAttachmentInput>;
  removedFiles?: Array<string>;
}

export interface GQLEditThreadPayload {
  thread: GQLThread;
}

export interface GQLFile {
  id: string;
  hash: string;
  type?: GQLFileTypeEnum;
  name: string;
  extension?: string;
  status: GQLFileStatusEnum;
  useTools: boolean;
  commentCount: number;
  author?: GQLProfile;
  hasNewVersion: boolean;
  hasNewComment: boolean;
  hasNewApprove: boolean;
  createdAt: GQLDateTime;
  updatedAt: GQLDateTime;
  versions?: Array<GQLFileVersion>;
  canRemove: boolean;
  canComment: boolean;
  canAddVersion: boolean;
  project: GQLProject;
  thread?: GQLThread;
  streamUrl?: string;
  unrealVersion?: GQLUnrealVersionEnum;
}

export interface GQLFileCollection {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLFileCollectionItem>;
}

export interface GQLFileCollectionItem {
  project: GQLProject;
  files: Array<GQLFileGroup>;
}

export interface GQLFileGroup {
  title: string;
  thread?: GQLThread;
  count: number;
  files: Array<GQLFile>;
}

export interface GQLFileList {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLFile>;
}

export enum GQLFileMarkerStatusEnum {
  ACTIVE = 'ACTIVE',
  RESOLVED = 'RESOLVED',
  REMOVED = 'REMOVED',
  ALL = 'ALL'
}

export enum GQLFileStatusEnum {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  REMOVED = 'REMOVED'
}

export enum GQLFileTypeEnum {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  MODEL = 'MODEL',
  STREAM = 'STREAM',
  EMBED = 'EMBED',
  OTHER = 'OTHER'
}

export type GQLFileUpload = any;

export interface GQLFileVersion {
  id: string;
  hash: string;
  title: string;
  serialNumber: number;
  status: GQLFileVersionStatusEnum;
  description?: string;
  author?: GQLProfile;
  approvedBy?: GQLProfile;
  path?: string;
  extension?: string;
  size?: number;
  markerGroups: Array<GQLMarkerGroup>;
  markerAutoincrementValue: number;
  previewPath?: string;
  isViewed: boolean;
  hasNewComment: boolean;
  canApprove: boolean;
  canDisapprove: boolean;
  canRemove: boolean;
  createdAt: GQLDateTime;
  streamConfig?: string;
}

export enum GQLFileVersionStatusEnum {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  REMOVED = 'REMOVED'
}

export interface GQLGenerateTokenInput {
  email: string;
  password: string;
}

export interface GQLInvitation {
  id: string;
  inviter: GQLProfile;
  email: string;
  role: GQLRolesEnum;
  status: GQLInvitationStatusEnum;
  expiresAt: GQLDateTime;
  projects: Array<GQLProject>;
}

export enum GQLInvitationActionStatusEnum {
  STATUS_NOT_EXISTS = 'STATUS_NOT_EXISTS',
  STATUS_EXPIRED = 'STATUS_EXPIRED',
  STATUS_ALREADY_ACCEPTED = 'STATUS_ALREADY_ACCEPTED',
  STATUS_REJECTED = 'STATUS_REJECTED',
  STATUS_AUTH_REQUIRED = 'STATUS_AUTH_REQUIRED',
  STATUS_ACCEPT_REQUIRED = 'STATUS_ACCEPT_REQUIRED',
  STATUS_REGISTRATION_REQUIRED = 'STATUS_REGISTRATION_REQUIRED'
}

export interface GQLInvitationStatus {
  status: GQLInvitationActionStatusEnum;
}

export enum GQLInvitationStatusEnum {
  NEW = 'NEW',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export interface GQLLeaveProjectInput {
  projectId: string;
}

export interface GQLLeaveProjectPayload {
  me: GQLMe;
}

export interface GQLMarkActivityAsViewedInput {
  ids: Array<string>;
}

export interface GQLMarkActivityAsViewedPayload {
  activities: Array<GQLActivity>;
}

export interface GQLMarkCommentAsViewedInput {
  ids: Array<string>;
}

export interface GQLMarkCommentAsViewedPayload {
  comments: Array<GQLComment>;
}

export interface GQLMarker {
  id: string;
  serialNumber: number;
  coordinates: string;
  status: GQLFileMarkerStatusEnum;
  comments: Array<GQLComment>;
  markerGroup: GQLMarkerGroup;
  hasNewComment: boolean;
  canResolve: boolean;
  canUnresolve: boolean;
  canRemove: boolean;
  createdAt: GQLDateTime;
}

export interface GQLMarkerGroup {
  id: string;
  imagePath?: string;
  previewPath?: string;
  configuration?: string;
  markers: Array<GQLMarker>;
  createdAt: GQLDateTime;
  imageUploadUrl?: string;
}

export interface GQLMarkFileApproveAsViewedInput {
  id: string;
}

export interface GQLMarkFileApproveAsViewedPayload {
  file?: GQLFile;
}

export interface GQLMarkFileVersionAsViewedInput {
  ids: Array<string>;
}

export interface GQLMarkFileVersionAsViewedPayload {
  fileVersions: Array<GQLFileVersion>;
}

export interface GQLMarkMessageAsViewedInput {
  ids: Array<string>;
}

export interface GQLMarkMessageAsViewedPayload {
  messages: Array<GQLMessage>;
}

export interface GQLMarkThreadAsViewedInput {
  id: string;
}

export interface GQLMarkThreadAsViewedPayload {
  thread: GQLThread;
}

export interface GQLMe {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  country?: GQLCountry;
  state?: string;
  city?: string;
  company?: GQLCompany;
  timezone?: GQLTimezone;
  avatarPath?: string;
  role?: GQLRolesEnum;
  availableRoles?: Array<GQLRolesEnum>;
  workspace?: GQLWorkspace;
  workspaces?: Array<GQLWorkspace>;
  projects: GQLProjectList;
  permissions: string;
  notificationSettings: GQLNotificationSettings;
}

export interface GQLMessage {
  id: string;
  parent?: GQLMessage;
  body?: string;
  author: GQLProfile;
  files: Array<GQLFile>;
  isViewed: boolean;
  isEdited: boolean;
  canEdit: boolean;
  canRemove: boolean;
  canReply: boolean;
  createdAt: GQLDateTime;
  updatedAt: GQLDateTime;
}

export interface GQLMessageEmailNotificationInput {
  profiles?: Array<string>;
  link?: string;
}

export interface GQLMessageList {
  total: number;
  skip: number;
  limit: number;
  unread: number;
  items: Array<GQLMessage>;
}

export interface GQLMutation {
  generateToken?: GQLTokensPayload;
  refreshToken?: GQLTokensPayload;
  createResetPasswordRequest?: GQLCreateResetPasswordRequestPayload;
  resetPassword?: GQLTokensPayload;
  updateMe?: GQLUpdateMePayload;
  editNotificationSettings?: GQLEditNotificationSettingsPayload;
  leaveProject?: GQLLeaveProjectPayload;
  updatePassword?: GQLUpdatePasswordPayload;
  editProfile?: GQLEditProfilePayload;
  removeProfile?: GQLRemovePayload;
  createCompany?: GQLCreateCompanyPayload;
  editCompany?: GQLEditCompanyPayload;
  removeCompany?: GQLRemovePayload;
  addCompanyProfile?: GQLAddCompanyProfilePayload;
  removeCompanyProfile?: GQLRemoveCompanyProfilePayload;
  createInvitation?: GQLCreateInvitationPayload;
  acceptInvitation?: GQLTokensPayload;
  removeInvitation?: GQLRemovePayload;
  createProject?: GQLCreateProjectPayload;
  editProject?: GQLEditProjectPayload;
  removeProject?: GQLRemovePayload;
  addCompanyToProject?: GQLAddCompanyToProjectPayload;
  createThread?: GQLCreateThreadPayload;
  editThread?: GQLEditThreadPayload;
  approveThread?: GQLApproveThreadPayload;
  disapproveThread?: GQLDisapproveThreadPayload;
  markThreadAsViewed?: GQLMarkThreadAsViewedPayload;
  removeThread?: GQLRemovePayload;
  createMessage?: GQLCreateMessagePayload;
  editMessage?: GQLEditMessagePayload;
  markMessageAsViewed?: GQLMarkMessageAsViewedPayload;
  removeMessage?: GQLRemovePayload;
  createFile?: GQLCreateFilePayload;
  markFileApproveAsViewed?: GQLMarkFileApproveAsViewedPayload;
  createFileVersion?: GQLCreateFileVersionPayload;
  approveFileVersion?: GQLApproveFileVersionPayload;
  disapproveFileVersion?: GQLDisapproveFileVersionPayload;
  markFileVersionAsViewed?: GQLMarkFileVersionAsViewedPayload;
  removeFile?: GQLRemovePayload;
  removeFileVersion?: GQLRemovePayload;
  createMarkerGroup?: GQLCreateMarkerGroupPayload;
  createMarker?: GQLCreateMarkerPayload;
  resolveMarker?: GQLResolveMarkerPayload;
  unresolveMarker?: GQLUnresolveMarkerPayload;
  removeMarker?: GQLRemovePayload;
  createComment?: GQLCreateCommentPayload;
  editComment?: GQLEditCommentPayload;
  removeComment?: GQLRemovePayload;
  markCommentAsViewed?: GQLMarkCommentAsViewedPayload;
  markActivityAsViewed?: GQLMarkActivityAsViewedPayload;
  clearActivities?: GQLClearActivitiesPayload;
}

export interface GQLNotificationSetting {
  isAppEnabled: boolean;
  isEmailEnabled: boolean;
}

export interface GQLNotificationSettingInput {
  isAppEnabled: boolean;
  isEmailEnabled: boolean;
}

export interface GQLNotificationSettings {
  isEnabled: boolean;
  onThreadCreate: GQLNotificationSetting;
  onThreadApprove: GQLNotificationSetting;
  onMessageCreate: GQLNotificationSetting;
  onFileUpdate: GQLNotificationSetting;
  onFileComment: GQLNotificationSetting;
  onFileApprove: GQLNotificationSetting;
}

export interface GQLProfile {
  id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  country?: GQLCountry;
  state?: string;
  city?: string;
  company?: GQLCompany;
  timezone?: GQLTimezone;
  avatarPath?: string;
  role?: GQLRolesEnum;
  availableRoles?: Array<GQLRolesEnum>;
}

export interface GQLProfileList {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLProfile>;
}

export interface GQLProfilePermissions {
  role?: GQLRolesEnum;
  reachableRoles?: Array<GQLRolesEnum>;
  canChangeRoles?: Array<GQLRolesEnum>;
}

export interface GQLProject {
  id: string;
  title: string;
  logoPath?: string;
  description?: string;
  startDate?: GQLDateTime;
  expirationDate?: GQLDateTime;
  author?: GQLProfile;
  profiles: Array<GQLProfile>;
  invitations: Array<GQLProjectInvitation>;
  threads: GQLThreadList;
  files: GQLFileList;
  status: GQLProjectStatusEnum;
  canEdit: boolean;
  canRemove: boolean;
  canAddFileWithoutThread: boolean;
  createdAt: GQLDateTime;
  updatedAt: GQLDateTime;
}

export interface GQLProjectInvitation {
  id: string;
  email: string;
  role: GQLRolesEnum;
  status: GQLInvitationStatusEnum;
}

export interface GQLProjectInvitationInput {
  email: string;
  isClient: boolean;
  acceptLink: string;
}

export interface GQLProjectList {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLProject>;
}

export enum GQLProjectStatusEnum {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  FINISHED = 'FINISHED',
  REMOVED = 'REMOVED'
}

export interface GQLQuery {
  status: string;
  countries: Array<GQLCountry>;
  timezones: Array<GQLTimezone>;
  me?: GQLMe;
  permissions?: GQLProfilePermissions;
  workspaces?: GQLWorkspaceList;
  workspace?: GQLWorkspace;
  companies?: GQLCompanyList;
  company?: GQLCompany;
  profiles?: GQLProfileList;
  profile?: GQLProfile;
  projects?: GQLProjectList;
  project?: GQLProject;
  projectFiles: Array<GQLFileGroup>;
  projectMembers: Array<GQLProfile>;
  thread?: GQLThread;
  threadFiles: Array<GQLFile>;
  threadFilesWithOriginOrder: Array<GQLFile>;
  files?: GQLFileCollection;
  file?: GQLFile;
  fileVersion?: GQLFileVersion;
  markerGroup?: GQLMarkerGroup;
  activities?: GQLActivityList;
  invitationStatus?: GQLInvitationStatus;
}

export interface GQLRefreshTokenInput {
  refreshToken: string;
}

export interface GQLRemoveCompanyProfileInput {
  companyId: string;
  profileId: string;
}

export interface GQLRemoveCompanyProfilePayload {
  company: GQLCompany;
}

export interface GQLRemoveInput {
  id: string;
}

export interface GQLRemovePayload {
  id: string;
  success: boolean;
}

export interface GQLResetPasswordInput {
  token: string;
  password: string;
}

export interface GQLResolveMarkerInput {
  id: string;
}

export interface GQLResolveMarkerPayload {
  marker: GQLMarker;
}

export enum GQLRolesEnum {
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
  ROLE_OWNER = 'ROLE_OWNER',
  ROLE_SUPER_MANAGER = 'ROLE_SUPER_MANAGER',
  ROLE_MANAGER = 'ROLE_MANAGER',
  ROLE_SUPER_CLIENT = 'ROLE_SUPER_CLIENT',
  ROLE_APPROVER = 'ROLE_APPROVER',
  ROLE_CLIENT = 'ROLE_CLIENT',
  ROLE_EMPLOYEE = 'ROLE_EMPLOYEE',
  ROLE_CLIENT_COMMUNICATOR = 'ROLE_CLIENT_COMMUNICATOR'
}

export interface GQLThread {
  id: string;
  title: string;
  serialNumber: number;
  body?: string;
  status: GQLThreadStatusEnum;
  accessLevel: GQLAccessLevelEnum;
  isViewed: boolean;
  author: GQLProfile;
  approvedBy?: GQLProfile;
  contributors: Array<GQLProfile>;
  subscribers: Array<GQLProfile>;
  messages: GQLMessageList;
  files: GQLFileList;
  ownFiles: Array<GQLFile>;
  canEdit: boolean;
  canRemove: boolean;
  canApprove: boolean;
  canDisapprove: boolean;
  canCreateMessage: boolean;
  canAddFile: boolean;
  createdAt: GQLDateTime;
  updatedAt: GQLDateTime;
}

export interface GQLThreadList {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLThread>;
}

export enum GQLThreadStatusEnum {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  REMOVED = 'REMOVED'
}

export interface GQLTimezone {
  code: string;
  name: string;
}

export interface GQLTokensPayload {
  token: string;
  refreshToken?: string;
  refreshTokenExpiration?: number;
}

export enum GQLUnrealVersionEnum {
  V_4 = 'V_4',
  V_5 = 'V_5'
}

export interface GQLUnresolveMarkerInput {
  id: string;
}

export interface GQLUnresolveMarkerPayload {
  marker: GQLMarker;
}

export interface GQLUpdateMeInput {
  firstName?: string;
  lastName?: string;
  countryCode?: string;
  state?: string;
  city?: string;
  timezoneId?: string;
  avatar?: GQLFileUpload;
}

export interface GQLUpdateMePayload {
  me: GQLMe;
}

export interface GQLUpdatePasswordInput {
  oldPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
}

export interface GQLUpdatePasswordPayload {
  me: GQLMe;
}

export interface GQLWorkspace {
  id: string;
  name: string;
  companies: GQLCompanyList;
  profiles: GQLProfileList;
}

export interface GQLWorkspaceList {
  total: number;
  skip: number;
  limit: number;
  items: Array<GQLWorkspace>;
}

/*********************************
 *                               *
 *         TYPE RESOLVERS        *
 *                               *
 *********************************/
/**
 * This interface define the shape of your resolver
 * Note that this type is designed to be compatible with graphql-tools resolvers
 * However, you can still use other generated interfaces to make your resolver type-safed
 */
export interface GQLResolver {
  Activity?: GQLActivityTypeResolver;
  ActivityList?: GQLActivityListTypeResolver;
  AddCompanyProfilePayload?: GQLAddCompanyProfilePayloadTypeResolver;
  AddCompanyToProjectPayload?: GQLAddCompanyToProjectPayloadTypeResolver;
  ApproveFileVersionPayload?: GQLApproveFileVersionPayloadTypeResolver;
  ApproveThreadPayload?: GQLApproveThreadPayloadTypeResolver;
  ClearActivitiesPayload?: GQLClearActivitiesPayloadTypeResolver;
  Comment?: GQLCommentTypeResolver;
  Company?: GQLCompanyTypeResolver;
  CompanyList?: GQLCompanyListTypeResolver;
  Country?: GQLCountryTypeResolver;
  CreateCommentPayload?: GQLCreateCommentPayloadTypeResolver;
  CreateCompanyPayload?: GQLCreateCompanyPayloadTypeResolver;
  CreateFilePayload?: GQLCreateFilePayloadTypeResolver;
  CreateFileVersionPayload?: GQLCreateFileVersionPayloadTypeResolver;
  CreateInvitationPayload?: GQLCreateInvitationPayloadTypeResolver;
  CreateMarkerGroupPayload?: GQLCreateMarkerGroupPayloadTypeResolver;
  CreateMarkerPayload?: GQLCreateMarkerPayloadTypeResolver;
  CreateMessagePayload?: GQLCreateMessagePayloadTypeResolver;
  CreateProjectPayload?: GQLCreateProjectPayloadTypeResolver;
  CreateResetPasswordRequestPayload?: GQLCreateResetPasswordRequestPayloadTypeResolver;
  CreateThreadPayload?: GQLCreateThreadPayloadTypeResolver;
  DateTime?: GraphQLScalarType;
  DisapproveFileVersionPayload?: GQLDisapproveFileVersionPayloadTypeResolver;
  DisapproveThreadPayload?: GQLDisapproveThreadPayloadTypeResolver;
  EditCommentPayload?: GQLEditCommentPayloadTypeResolver;
  EditCompanyPayload?: GQLEditCompanyPayloadTypeResolver;
  EditMessagePayload?: GQLEditMessagePayloadTypeResolver;
  EditNotificationSettingsPayload?: GQLEditNotificationSettingsPayloadTypeResolver;
  EditProfilePayload?: GQLEditProfilePayloadTypeResolver;
  EditProjectPayload?: GQLEditProjectPayloadTypeResolver;
  EditThreadPayload?: GQLEditThreadPayloadTypeResolver;
  File?: GQLFileTypeResolver;
  FileCollection?: GQLFileCollectionTypeResolver;
  FileCollectionItem?: GQLFileCollectionItemTypeResolver;
  FileGroup?: GQLFileGroupTypeResolver;
  FileList?: GQLFileListTypeResolver;
  FileUpload?: GraphQLScalarType;
  FileVersion?: GQLFileVersionTypeResolver;
  Invitation?: GQLInvitationTypeResolver;
  InvitationStatus?: GQLInvitationStatusTypeResolver;
  LeaveProjectPayload?: GQLLeaveProjectPayloadTypeResolver;
  MarkActivityAsViewedPayload?: GQLMarkActivityAsViewedPayloadTypeResolver;
  MarkCommentAsViewedPayload?: GQLMarkCommentAsViewedPayloadTypeResolver;
  Marker?: GQLMarkerTypeResolver;
  MarkerGroup?: GQLMarkerGroupTypeResolver;
  MarkFileApproveAsViewedPayload?: GQLMarkFileApproveAsViewedPayloadTypeResolver;
  MarkFileVersionAsViewedPayload?: GQLMarkFileVersionAsViewedPayloadTypeResolver;
  MarkMessageAsViewedPayload?: GQLMarkMessageAsViewedPayloadTypeResolver;
  MarkThreadAsViewedPayload?: GQLMarkThreadAsViewedPayloadTypeResolver;
  Me?: GQLMeTypeResolver;
  Message?: GQLMessageTypeResolver;
  MessageList?: GQLMessageListTypeResolver;
  Mutation?: GQLMutationTypeResolver;
  NotificationSetting?: GQLNotificationSettingTypeResolver;
  NotificationSettings?: GQLNotificationSettingsTypeResolver;
  Profile?: GQLProfileTypeResolver;
  ProfileList?: GQLProfileListTypeResolver;
  ProfilePermissions?: GQLProfilePermissionsTypeResolver;
  Project?: GQLProjectTypeResolver;
  ProjectInvitation?: GQLProjectInvitationTypeResolver;
  ProjectList?: GQLProjectListTypeResolver;
  Query?: GQLQueryTypeResolver;
  RemoveCompanyProfilePayload?: GQLRemoveCompanyProfilePayloadTypeResolver;
  RemovePayload?: GQLRemovePayloadTypeResolver;
  ResolveMarkerPayload?: GQLResolveMarkerPayloadTypeResolver;
  Thread?: GQLThreadTypeResolver;
  ThreadList?: GQLThreadListTypeResolver;
  Timezone?: GQLTimezoneTypeResolver;
  TokensPayload?: GQLTokensPayloadTypeResolver;
  UnresolveMarkerPayload?: GQLUnresolveMarkerPayloadTypeResolver;
  UpdateMePayload?: GQLUpdateMePayloadTypeResolver;
  UpdatePasswordPayload?: GQLUpdatePasswordPayloadTypeResolver;
  Workspace?: GQLWorkspaceTypeResolver;
  WorkspaceList?: GQLWorkspaceListTypeResolver;
}
export interface GQLActivityTypeResolver<TParent = any> {
  id?: ActivityToIdResolver<TParent>;
  type?: ActivityToTypeResolver<TParent>;
  author?: ActivityToAuthorResolver<TParent>;
  project?: ActivityToProjectResolver<TParent>;
  thread?: ActivityToThreadResolver<TParent>;
  message?: ActivityToMessageResolver<TParent>;
  file?: ActivityToFileResolver<TParent>;
  fileVersion?: ActivityToFileVersionResolver<TParent>;
  comment?: ActivityToCommentResolver<TParent>;
  createdAt?: ActivityToCreatedAtResolver<TParent>;
  isViewed?: ActivityToIsViewedResolver<TParent>;
}

export interface ActivityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToIsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActivityListTypeResolver<TParent = any> {
  total?: ActivityListToTotalResolver<TParent>;
  skip?: ActivityListToSkipResolver<TParent>;
  limit?: ActivityListToLimitResolver<TParent>;
  unread?: ActivityListToUnreadResolver<TParent>;
  items?: ActivityListToItemsResolver<TParent>;
}

export interface ActivityListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityListToUnreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAddCompanyProfilePayloadTypeResolver<TParent = any> {
  company?: AddCompanyProfilePayloadToCompanyResolver<TParent>;
}

export interface AddCompanyProfilePayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAddCompanyToProjectPayloadTypeResolver<TParent = any> {
  project?: AddCompanyToProjectPayloadToProjectResolver<TParent>;
}

export interface AddCompanyToProjectPayloadToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLApproveFileVersionPayloadTypeResolver<TParent = any> {
  fileVersion?: ApproveFileVersionPayloadToFileVersionResolver<TParent>;
}

export interface ApproveFileVersionPayloadToFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLApproveThreadPayloadTypeResolver<TParent = any> {
  thread?: ApproveThreadPayloadToThreadResolver<TParent>;
}

export interface ApproveThreadPayloadToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLClearActivitiesPayloadTypeResolver<TParent = any> {
  activities?: ClearActivitiesPayloadToActivitiesResolver<TParent>;
}

export interface ClearActivitiesPayloadToActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommentTypeResolver<TParent = any> {
  id?: CommentToIdResolver<TParent>;
  body?: CommentToBodyResolver<TParent>;
  author?: CommentToAuthorResolver<TParent>;
  marker?: CommentToMarkerResolver<TParent>;
  isViewed?: CommentToIsViewedResolver<TParent>;
  isEdited?: CommentToIsEditedResolver<TParent>;
  canEdit?: CommentToCanEditResolver<TParent>;
  canRemove?: CommentToCanRemoveResolver<TParent>;
  createdAt?: CommentToCreatedAtResolver<TParent>;
  updatedAt?: CommentToUpdatedAtResolver<TParent>;
}

export interface CommentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToBodyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToIsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToIsEditedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToCanEditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommentToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCompanyTypeResolver<TParent = any> {
  id?: CompanyToIdResolver<TParent>;
  name?: CompanyToNameResolver<TParent>;
  profiles?: CompanyToProfilesResolver<TParent>;
}

export interface CompanyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToProfilesArgs {
  limit?: number;
  skip?: number;
}
export interface CompanyToProfilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CompanyToProfilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCompanyListTypeResolver<TParent = any> {
  total?: CompanyListToTotalResolver<TParent>;
  skip?: CompanyListToSkipResolver<TParent>;
  limit?: CompanyListToLimitResolver<TParent>;
  items?: CompanyListToItemsResolver<TParent>;
}

export interface CompanyListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCountryTypeResolver<TParent = any> {
  code?: CountryToCodeResolver<TParent>;
  name?: CountryToNameResolver<TParent>;
}

export interface CountryToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CountryToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommentPayloadTypeResolver<TParent = any> {
  comment?: CreateCommentPayloadToCommentResolver<TParent>;
}

export interface CreateCommentPayloadToCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCompanyPayloadTypeResolver<TParent = any> {
  company?: CreateCompanyPayloadToCompanyResolver<TParent>;
}

export interface CreateCompanyPayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateFilePayloadTypeResolver<TParent = any> {
  files?: CreateFilePayloadToFilesResolver<TParent>;
}

export interface CreateFilePayloadToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateFileVersionPayloadTypeResolver<TParent = any> {
  fileVersion?: CreateFileVersionPayloadToFileVersionResolver<TParent>;
}

export interface CreateFileVersionPayloadToFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateInvitationPayloadTypeResolver<TParent = any> {
  invitation?: CreateInvitationPayloadToInvitationResolver<TParent>;
}

export interface CreateInvitationPayloadToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateMarkerGroupPayloadTypeResolver<TParent = any> {
  markerGroup?: CreateMarkerGroupPayloadToMarkerGroupResolver<TParent>;
}

export interface CreateMarkerGroupPayloadToMarkerGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateMarkerPayloadTypeResolver<TParent = any> {
  marker?: CreateMarkerPayloadToMarkerResolver<TParent>;
}

export interface CreateMarkerPayloadToMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateMessagePayloadTypeResolver<TParent = any> {
  message?: CreateMessagePayloadToMessageResolver<TParent>;
}

export interface CreateMessagePayloadToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateProjectPayloadTypeResolver<TParent = any> {
  project?: CreateProjectPayloadToProjectResolver<TParent>;
}

export interface CreateProjectPayloadToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateResetPasswordRequestPayloadTypeResolver<TParent = any> {
  success?: CreateResetPasswordRequestPayloadToSuccessResolver<TParent>;
}

export interface CreateResetPasswordRequestPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateThreadPayloadTypeResolver<TParent = any> {
  thread?: CreateThreadPayloadToThreadResolver<TParent>;
}

export interface CreateThreadPayloadToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDisapproveFileVersionPayloadTypeResolver<TParent = any> {
  fileVersion?: DisapproveFileVersionPayloadToFileVersionResolver<TParent>;
}

export interface DisapproveFileVersionPayloadToFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDisapproveThreadPayloadTypeResolver<TParent = any> {
  thread?: DisapproveThreadPayloadToThreadResolver<TParent>;
}

export interface DisapproveThreadPayloadToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditCommentPayloadTypeResolver<TParent = any> {
  comment?: EditCommentPayloadToCommentResolver<TParent>;
}

export interface EditCommentPayloadToCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditCompanyPayloadTypeResolver<TParent = any> {
  company?: EditCompanyPayloadToCompanyResolver<TParent>;
}

export interface EditCompanyPayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditMessagePayloadTypeResolver<TParent = any> {
  message?: EditMessagePayloadToMessageResolver<TParent>;
}

export interface EditMessagePayloadToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditNotificationSettingsPayloadTypeResolver<TParent = any> {
  me?: EditNotificationSettingsPayloadToMeResolver<TParent>;
}

export interface EditNotificationSettingsPayloadToMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditProfilePayloadTypeResolver<TParent = any> {
  profile?: EditProfilePayloadToProfileResolver<TParent>;
}

export interface EditProfilePayloadToProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditProjectPayloadTypeResolver<TParent = any> {
  project?: EditProjectPayloadToProjectResolver<TParent>;
}

export interface EditProjectPayloadToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEditThreadPayloadTypeResolver<TParent = any> {
  thread?: EditThreadPayloadToThreadResolver<TParent>;
}

export interface EditThreadPayloadToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileTypeResolver<TParent = any> {
  id?: FileToIdResolver<TParent>;
  hash?: FileToHashResolver<TParent>;
  type?: FileToTypeResolver<TParent>;
  name?: FileToNameResolver<TParent>;
  extension?: FileToExtensionResolver<TParent>;
  status?: FileToStatusResolver<TParent>;
  useTools?: FileToUseToolsResolver<TParent>;
  commentCount?: FileToCommentCountResolver<TParent>;
  author?: FileToAuthorResolver<TParent>;
  hasNewVersion?: FileToHasNewVersionResolver<TParent>;
  hasNewComment?: FileToHasNewCommentResolver<TParent>;
  hasNewApprove?: FileToHasNewApproveResolver<TParent>;
  createdAt?: FileToCreatedAtResolver<TParent>;
  updatedAt?: FileToUpdatedAtResolver<TParent>;
  versions?: FileToVersionsResolver<TParent>;
  canRemove?: FileToCanRemoveResolver<TParent>;
  canComment?: FileToCanCommentResolver<TParent>;
  canAddVersion?: FileToCanAddVersionResolver<TParent>;
  project?: FileToProjectResolver<TParent>;
  thread?: FileToThreadResolver<TParent>;
  streamUrl?: FileToStreamUrlResolver<TParent>;
  unrealVersion?: FileToUnrealVersionResolver<TParent>;
}

export interface FileToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToHashResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToExtensionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToUseToolsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToCommentCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToHasNewVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToHasNewCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToHasNewApproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToVersionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToCanCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToCanAddVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToStreamUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileToUnrealVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileCollectionTypeResolver<TParent = any> {
  total?: FileCollectionToTotalResolver<TParent>;
  skip?: FileCollectionToSkipResolver<TParent>;
  limit?: FileCollectionToLimitResolver<TParent>;
  items?: FileCollectionToItemsResolver<TParent>;
}

export interface FileCollectionToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileCollectionToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileCollectionToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileCollectionToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileCollectionItemTypeResolver<TParent = any> {
  project?: FileCollectionItemToProjectResolver<TParent>;
  files?: FileCollectionItemToFilesResolver<TParent>;
}

export interface FileCollectionItemToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileCollectionItemToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileGroupTypeResolver<TParent = any> {
  title?: FileGroupToTitleResolver<TParent>;
  thread?: FileGroupToThreadResolver<TParent>;
  count?: FileGroupToCountResolver<TParent>;
  files?: FileGroupToFilesResolver<TParent>;
}

export interface FileGroupToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileGroupToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileGroupToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileGroupToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileListTypeResolver<TParent = any> {
  total?: FileListToTotalResolver<TParent>;
  skip?: FileListToSkipResolver<TParent>;
  limit?: FileListToLimitResolver<TParent>;
  items?: FileListToItemsResolver<TParent>;
}

export interface FileListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileVersionTypeResolver<TParent = any> {
  id?: FileVersionToIdResolver<TParent>;
  hash?: FileVersionToHashResolver<TParent>;
  title?: FileVersionToTitleResolver<TParent>;
  serialNumber?: FileVersionToSerialNumberResolver<TParent>;
  status?: FileVersionToStatusResolver<TParent>;
  description?: FileVersionToDescriptionResolver<TParent>;
  author?: FileVersionToAuthorResolver<TParent>;
  approvedBy?: FileVersionToApprovedByResolver<TParent>;
  path?: FileVersionToPathResolver<TParent>;
  extension?: FileVersionToExtensionResolver<TParent>;
  size?: FileVersionToSizeResolver<TParent>;
  markerGroups?: FileVersionToMarkerGroupsResolver<TParent>;
  markerAutoincrementValue?: FileVersionToMarkerAutoincrementValueResolver<TParent>;
  previewPath?: FileVersionToPreviewPathResolver<TParent>;
  isViewed?: FileVersionToIsViewedResolver<TParent>;
  hasNewComment?: FileVersionToHasNewCommentResolver<TParent>;
  canApprove?: FileVersionToCanApproveResolver<TParent>;
  canDisapprove?: FileVersionToCanDisapproveResolver<TParent>;
  canRemove?: FileVersionToCanRemoveResolver<TParent>;
  createdAt?: FileVersionToCreatedAtResolver<TParent>;
  streamConfig?: FileVersionToStreamConfigResolver<TParent>;
}

export interface FileVersionToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToHashResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToSerialNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToApprovedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToExtensionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToSizeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToMarkerGroupsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToMarkerAutoincrementValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToPreviewPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToIsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToHasNewCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToCanApproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToCanDisapproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileVersionToStreamConfigResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvitationTypeResolver<TParent = any> {
  id?: InvitationToIdResolver<TParent>;
  inviter?: InvitationToInviterResolver<TParent>;
  email?: InvitationToEmailResolver<TParent>;
  role?: InvitationToRoleResolver<TParent>;
  status?: InvitationToStatusResolver<TParent>;
  expiresAt?: InvitationToExpiresAtResolver<TParent>;
  projects?: InvitationToProjectsResolver<TParent>;
}

export interface InvitationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToInviterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToProjectsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvitationStatusTypeResolver<TParent = any> {
  status?: InvitationStatusToStatusResolver<TParent>;
}

export interface InvitationStatusToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLeaveProjectPayloadTypeResolver<TParent = any> {
  me?: LeaveProjectPayloadToMeResolver<TParent>;
}

export interface LeaveProjectPayloadToMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkActivityAsViewedPayloadTypeResolver<TParent = any> {
  activities?: MarkActivityAsViewedPayloadToActivitiesResolver<TParent>;
}

export interface MarkActivityAsViewedPayloadToActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkCommentAsViewedPayloadTypeResolver<TParent = any> {
  comments?: MarkCommentAsViewedPayloadToCommentsResolver<TParent>;
}

export interface MarkCommentAsViewedPayloadToCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkerTypeResolver<TParent = any> {
  id?: MarkerToIdResolver<TParent>;
  serialNumber?: MarkerToSerialNumberResolver<TParent>;
  coordinates?: MarkerToCoordinatesResolver<TParent>;
  status?: MarkerToStatusResolver<TParent>;
  comments?: MarkerToCommentsResolver<TParent>;
  markerGroup?: MarkerToMarkerGroupResolver<TParent>;
  hasNewComment?: MarkerToHasNewCommentResolver<TParent>;
  canResolve?: MarkerToCanResolveResolver<TParent>;
  canUnresolve?: MarkerToCanUnresolveResolver<TParent>;
  canRemove?: MarkerToCanRemoveResolver<TParent>;
  createdAt?: MarkerToCreatedAtResolver<TParent>;
}

export interface MarkerToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToSerialNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToCoordinatesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToMarkerGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToHasNewCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToCanResolveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToCanUnresolveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkerGroupTypeResolver<TParent = any> {
  id?: MarkerGroupToIdResolver<TParent>;
  imagePath?: MarkerGroupToImagePathResolver<TParent>;
  previewPath?: MarkerGroupToPreviewPathResolver<TParent>;
  configuration?: MarkerGroupToConfigurationResolver<TParent>;
  markers?: MarkerGroupToMarkersResolver<TParent>;
  createdAt?: MarkerGroupToCreatedAtResolver<TParent>;
  imageUploadUrl?: MarkerGroupToImageUploadUrlResolver<TParent>;
}

export interface MarkerGroupToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerGroupToImagePathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerGroupToPreviewPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerGroupToConfigurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerGroupToMarkersArgs {
  status?: GQLFileMarkerStatusEnum;
}
export interface MarkerGroupToMarkersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MarkerGroupToMarkersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerGroupToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MarkerGroupToImageUploadUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkFileApproveAsViewedPayloadTypeResolver<TParent = any> {
  file?: MarkFileApproveAsViewedPayloadToFileResolver<TParent>;
}

export interface MarkFileApproveAsViewedPayloadToFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkFileVersionAsViewedPayloadTypeResolver<TParent = any> {
  fileVersions?: MarkFileVersionAsViewedPayloadToFileVersionsResolver<TParent>;
}

export interface MarkFileVersionAsViewedPayloadToFileVersionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkMessageAsViewedPayloadTypeResolver<TParent = any> {
  messages?: MarkMessageAsViewedPayloadToMessagesResolver<TParent>;
}

export interface MarkMessageAsViewedPayloadToMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMarkThreadAsViewedPayloadTypeResolver<TParent = any> {
  thread?: MarkThreadAsViewedPayloadToThreadResolver<TParent>;
}

export interface MarkThreadAsViewedPayloadToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMeTypeResolver<TParent = any> {
  id?: MeToIdResolver<TParent>;
  email?: MeToEmailResolver<TParent>;
  firstName?: MeToFirstNameResolver<TParent>;
  lastName?: MeToLastNameResolver<TParent>;
  fullName?: MeToFullNameResolver<TParent>;
  country?: MeToCountryResolver<TParent>;
  state?: MeToStateResolver<TParent>;
  city?: MeToCityResolver<TParent>;
  company?: MeToCompanyResolver<TParent>;
  timezone?: MeToTimezoneResolver<TParent>;
  avatarPath?: MeToAvatarPathResolver<TParent>;
  role?: MeToRoleResolver<TParent>;
  availableRoles?: MeToAvailableRolesResolver<TParent>;
  workspace?: MeToWorkspaceResolver<TParent>;
  workspaces?: MeToWorkspacesResolver<TParent>;
  projects?: MeToProjectsResolver<TParent>;
  permissions?: MeToPermissionsResolver<TParent>;
  notificationSettings?: MeToNotificationSettingsResolver<TParent>;
}

export interface MeToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToFullNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToCityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToTimezoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToAvatarPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToAvailableRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToWorkspaceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToWorkspacesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToProjectsArgs {
  limit?: number;
  skip?: number;
}
export interface MeToProjectsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MeToProjectsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToPermissionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MeToNotificationSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMessageTypeResolver<TParent = any> {
  id?: MessageToIdResolver<TParent>;
  parent?: MessageToParentResolver<TParent>;
  body?: MessageToBodyResolver<TParent>;
  author?: MessageToAuthorResolver<TParent>;
  files?: MessageToFilesResolver<TParent>;
  isViewed?: MessageToIsViewedResolver<TParent>;
  isEdited?: MessageToIsEditedResolver<TParent>;
  canEdit?: MessageToCanEditResolver<TParent>;
  canRemove?: MessageToCanRemoveResolver<TParent>;
  canReply?: MessageToCanReplyResolver<TParent>;
  createdAt?: MessageToCreatedAtResolver<TParent>;
  updatedAt?: MessageToUpdatedAtResolver<TParent>;
}

export interface MessageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToParentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToBodyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToIsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToIsEditedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToCanEditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToCanReplyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMessageListTypeResolver<TParent = any> {
  total?: MessageListToTotalResolver<TParent>;
  skip?: MessageListToSkipResolver<TParent>;
  limit?: MessageListToLimitResolver<TParent>;
  unread?: MessageListToUnreadResolver<TParent>;
  items?: MessageListToItemsResolver<TParent>;
}

export interface MessageListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageListToUnreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMutationTypeResolver<TParent = any> {
  generateToken?: MutationToGenerateTokenResolver<TParent>;
  refreshToken?: MutationToRefreshTokenResolver<TParent>;
  createResetPasswordRequest?: MutationToCreateResetPasswordRequestResolver<TParent>;
  resetPassword?: MutationToResetPasswordResolver<TParent>;
  updateMe?: MutationToUpdateMeResolver<TParent>;
  editNotificationSettings?: MutationToEditNotificationSettingsResolver<TParent>;
  leaveProject?: MutationToLeaveProjectResolver<TParent>;
  updatePassword?: MutationToUpdatePasswordResolver<TParent>;
  editProfile?: MutationToEditProfileResolver<TParent>;
  removeProfile?: MutationToRemoveProfileResolver<TParent>;
  createCompany?: MutationToCreateCompanyResolver<TParent>;
  editCompany?: MutationToEditCompanyResolver<TParent>;
  removeCompany?: MutationToRemoveCompanyResolver<TParent>;
  addCompanyProfile?: MutationToAddCompanyProfileResolver<TParent>;
  removeCompanyProfile?: MutationToRemoveCompanyProfileResolver<TParent>;
  createInvitation?: MutationToCreateInvitationResolver<TParent>;
  acceptInvitation?: MutationToAcceptInvitationResolver<TParent>;
  removeInvitation?: MutationToRemoveInvitationResolver<TParent>;
  createProject?: MutationToCreateProjectResolver<TParent>;
  editProject?: MutationToEditProjectResolver<TParent>;
  removeProject?: MutationToRemoveProjectResolver<TParent>;
  addCompanyToProject?: MutationToAddCompanyToProjectResolver<TParent>;
  createThread?: MutationToCreateThreadResolver<TParent>;
  editThread?: MutationToEditThreadResolver<TParent>;
  approveThread?: MutationToApproveThreadResolver<TParent>;
  disapproveThread?: MutationToDisapproveThreadResolver<TParent>;
  markThreadAsViewed?: MutationToMarkThreadAsViewedResolver<TParent>;
  removeThread?: MutationToRemoveThreadResolver<TParent>;
  createMessage?: MutationToCreateMessageResolver<TParent>;
  editMessage?: MutationToEditMessageResolver<TParent>;
  markMessageAsViewed?: MutationToMarkMessageAsViewedResolver<TParent>;
  removeMessage?: MutationToRemoveMessageResolver<TParent>;
  createFile?: MutationToCreateFileResolver<TParent>;
  markFileApproveAsViewed?: MutationToMarkFileApproveAsViewedResolver<TParent>;
  createFileVersion?: MutationToCreateFileVersionResolver<TParent>;
  approveFileVersion?: MutationToApproveFileVersionResolver<TParent>;
  disapproveFileVersion?: MutationToDisapproveFileVersionResolver<TParent>;
  markFileVersionAsViewed?: MutationToMarkFileVersionAsViewedResolver<TParent>;
  removeFile?: MutationToRemoveFileResolver<TParent>;
  removeFileVersion?: MutationToRemoveFileVersionResolver<TParent>;
  createMarkerGroup?: MutationToCreateMarkerGroupResolver<TParent>;
  createMarker?: MutationToCreateMarkerResolver<TParent>;
  resolveMarker?: MutationToResolveMarkerResolver<TParent>;
  unresolveMarker?: MutationToUnresolveMarkerResolver<TParent>;
  removeMarker?: MutationToRemoveMarkerResolver<TParent>;
  createComment?: MutationToCreateCommentResolver<TParent>;
  editComment?: MutationToEditCommentResolver<TParent>;
  removeComment?: MutationToRemoveCommentResolver<TParent>;
  markCommentAsViewed?: MutationToMarkCommentAsViewedResolver<TParent>;
  markActivityAsViewed?: MutationToMarkActivityAsViewedResolver<TParent>;
  clearActivities?: MutationToClearActivitiesResolver<TParent>;
}

export interface MutationToGenerateTokenArgs {
  input: GQLGenerateTokenInput;
}
export interface MutationToGenerateTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateTokenArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRefreshTokenArgs {
  input: GQLRefreshTokenInput;
}
export interface MutationToRefreshTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRefreshTokenArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateResetPasswordRequestArgs {
  input: GQLCreateResetPasswordRequestInput;
}
export interface MutationToCreateResetPasswordRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateResetPasswordRequestArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResetPasswordArgs {
  input: GQLResetPasswordInput;
}
export interface MutationToResetPasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResetPasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateMeArgs {
  input: GQLUpdateMeInput;
}
export interface MutationToUpdateMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateMeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditNotificationSettingsArgs {
  input: GQLEditNotificationSettingsInput;
}
export interface MutationToEditNotificationSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditNotificationSettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLeaveProjectArgs {
  input: GQLLeaveProjectInput;
}
export interface MutationToLeaveProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLeaveProjectArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePasswordArgs {
  input: GQLUpdatePasswordInput;
}
export interface MutationToUpdatePasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditProfileArgs {
  input: GQLEditProfileInput;
}
export interface MutationToEditProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditProfileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveProfileArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveProfileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCompanyArgs {
  input: GQLCreateCompanyInput;
}
export interface MutationToCreateCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditCompanyArgs {
  input: GQLEditCompanyInput;
}
export interface MutationToEditCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveCompanyArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAddCompanyProfileArgs {
  input: GQLAddCompanyProfileInput;
}
export interface MutationToAddCompanyProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAddCompanyProfileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveCompanyProfileArgs {
  input: GQLRemoveCompanyProfileInput;
}
export interface MutationToRemoveCompanyProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveCompanyProfileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateInvitationArgs {
  input: GQLCreateInvitationInput;
}
export interface MutationToCreateInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAcceptInvitationArgs {
  input: GQLAcceptInvitationInput;
}
export interface MutationToAcceptInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAcceptInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveInvitationArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateProjectArgs {
  input: GQLCreateProjectInput;
}
export interface MutationToCreateProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateProjectArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditProjectArgs {
  input: GQLEditProjectInput;
}
export interface MutationToEditProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditProjectArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveProjectArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveProjectArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAddCompanyToProjectArgs {
  input: GQLAddCompanyToProjectInput;
}
export interface MutationToAddCompanyToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAddCompanyToProjectArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateThreadArgs {
  input: GQLCreateThreadInput;
}
export interface MutationToCreateThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateThreadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditThreadArgs {
  input: GQLEditThreadInput;
}
export interface MutationToEditThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditThreadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToApproveThreadArgs {
  input: GQLApproveThreadInput;
}
export interface MutationToApproveThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToApproveThreadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDisapproveThreadArgs {
  input: GQLDisapproveThreadInput;
}
export interface MutationToDisapproveThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDisapproveThreadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMarkThreadAsViewedArgs {
  input: GQLMarkThreadAsViewedInput;
}
export interface MutationToMarkThreadAsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMarkThreadAsViewedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveThreadArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveThreadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateMessageArgs {
  input: GQLCreateMessageInput;
}
export interface MutationToCreateMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditMessageArgs {
  input: GQLEditMessageInput;
}
export interface MutationToEditMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMarkMessageAsViewedArgs {
  input: GQLMarkMessageAsViewedInput;
}
export interface MutationToMarkMessageAsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMarkMessageAsViewedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveMessageArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFileArgs {
  input: GQLCreateFileInput;
}
export interface MutationToCreateFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMarkFileApproveAsViewedArgs {
  input: GQLMarkFileApproveAsViewedInput;
}
export interface MutationToMarkFileApproveAsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMarkFileApproveAsViewedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFileVersionArgs {
  input: GQLCreateFileVersionInput;
}
export interface MutationToCreateFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFileVersionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToApproveFileVersionArgs {
  input: GQLApproveFileVersionInput;
}
export interface MutationToApproveFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToApproveFileVersionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDisapproveFileVersionArgs {
  input: GQLDisapproveFileVersionInput;
}
export interface MutationToDisapproveFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDisapproveFileVersionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMarkFileVersionAsViewedArgs {
  input: GQLMarkFileVersionAsViewedInput;
}
export interface MutationToMarkFileVersionAsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMarkFileVersionAsViewedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveFileArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveFileVersionArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveFileVersionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateMarkerGroupArgs {
  input: GQLCreateMarkerGroupInput;
}
export interface MutationToCreateMarkerGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateMarkerGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateMarkerArgs {
  input: GQLCreateMarkerInput;
}
export interface MutationToCreateMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateMarkerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResolveMarkerArgs {
  input: GQLResolveMarkerInput;
}
export interface MutationToResolveMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResolveMarkerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUnresolveMarkerArgs {
  input: GQLUnresolveMarkerInput;
}
export interface MutationToUnresolveMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUnresolveMarkerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveMarkerArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveMarkerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommentArgs {
  input: GQLCreateCommentInput;
}
export interface MutationToCreateCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEditCommentArgs {
  input: GQLEditCommentInput;
}
export interface MutationToEditCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEditCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveCommentArgs {
  input: GQLRemoveInput;
}
export interface MutationToRemoveCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveCommentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMarkCommentAsViewedArgs {
  input: GQLMarkCommentAsViewedInput;
}
export interface MutationToMarkCommentAsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMarkCommentAsViewedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMarkActivityAsViewedArgs {
  input: GQLMarkActivityAsViewedInput;
}
export interface MutationToMarkActivityAsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMarkActivityAsViewedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToClearActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotificationSettingTypeResolver<TParent = any> {
  isAppEnabled?: NotificationSettingToIsAppEnabledResolver<TParent>;
  isEmailEnabled?: NotificationSettingToIsEmailEnabledResolver<TParent>;
}

export interface NotificationSettingToIsAppEnabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingToIsEmailEnabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotificationSettingsTypeResolver<TParent = any> {
  isEnabled?: NotificationSettingsToIsEnabledResolver<TParent>;
  onThreadCreate?: NotificationSettingsToOnThreadCreateResolver<TParent>;
  onThreadApprove?: NotificationSettingsToOnThreadApproveResolver<TParent>;
  onMessageCreate?: NotificationSettingsToOnMessageCreateResolver<TParent>;
  onFileUpdate?: NotificationSettingsToOnFileUpdateResolver<TParent>;
  onFileComment?: NotificationSettingsToOnFileCommentResolver<TParent>;
  onFileApprove?: NotificationSettingsToOnFileApproveResolver<TParent>;
}

export interface NotificationSettingsToIsEnabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingsToOnThreadCreateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingsToOnThreadApproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingsToOnMessageCreateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingsToOnFileUpdateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingsToOnFileCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationSettingsToOnFileApproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProfileTypeResolver<TParent = any> {
  id?: ProfileToIdResolver<TParent>;
  email?: ProfileToEmailResolver<TParent>;
  firstName?: ProfileToFirstNameResolver<TParent>;
  lastName?: ProfileToLastNameResolver<TParent>;
  fullName?: ProfileToFullNameResolver<TParent>;
  country?: ProfileToCountryResolver<TParent>;
  state?: ProfileToStateResolver<TParent>;
  city?: ProfileToCityResolver<TParent>;
  company?: ProfileToCompanyResolver<TParent>;
  timezone?: ProfileToTimezoneResolver<TParent>;
  avatarPath?: ProfileToAvatarPathResolver<TParent>;
  role?: ProfileToRoleResolver<TParent>;
  availableRoles?: ProfileToAvailableRolesResolver<TParent>;
}

export interface ProfileToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToFullNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToCityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToTimezoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToAvatarPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileToAvailableRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProfileListTypeResolver<TParent = any> {
  total?: ProfileListToTotalResolver<TParent>;
  skip?: ProfileListToSkipResolver<TParent>;
  limit?: ProfileListToLimitResolver<TParent>;
  items?: ProfileListToItemsResolver<TParent>;
}

export interface ProfileListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfileListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProfilePermissionsTypeResolver<TParent = any> {
  role?: ProfilePermissionsToRoleResolver<TParent>;
  reachableRoles?: ProfilePermissionsToReachableRolesResolver<TParent>;
  canChangeRoles?: ProfilePermissionsToCanChangeRolesResolver<TParent>;
}

export interface ProfilePermissionsToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfilePermissionsToReachableRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProfilePermissionsToCanChangeRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProjectTypeResolver<TParent = any> {
  id?: ProjectToIdResolver<TParent>;
  title?: ProjectToTitleResolver<TParent>;
  logoPath?: ProjectToLogoPathResolver<TParent>;
  description?: ProjectToDescriptionResolver<TParent>;
  startDate?: ProjectToStartDateResolver<TParent>;
  expirationDate?: ProjectToExpirationDateResolver<TParent>;
  author?: ProjectToAuthorResolver<TParent>;
  profiles?: ProjectToProfilesResolver<TParent>;
  invitations?: ProjectToInvitationsResolver<TParent>;
  threads?: ProjectToThreadsResolver<TParent>;
  files?: ProjectToFilesResolver<TParent>;
  status?: ProjectToStatusResolver<TParent>;
  canEdit?: ProjectToCanEditResolver<TParent>;
  canRemove?: ProjectToCanRemoveResolver<TParent>;
  canAddFileWithoutThread?: ProjectToCanAddFileWithoutThreadResolver<TParent>;
  createdAt?: ProjectToCreatedAtResolver<TParent>;
  updatedAt?: ProjectToUpdatedAtResolver<TParent>;
}

export interface ProjectToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToLogoPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToExpirationDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToProfilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToThreadsArgs {
  limit?: number;
  skip?: number;
  status?: GQLThreadStatusEnum;
  searchQuery?: string;
}
export interface ProjectToThreadsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ProjectToThreadsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToFilesArgs {
  limit?: number;
  skip?: number;
}
export interface ProjectToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ProjectToFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToCanEditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToCanAddFileWithoutThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProjectInvitationTypeResolver<TParent = any> {
  id?: ProjectInvitationToIdResolver<TParent>;
  email?: ProjectInvitationToEmailResolver<TParent>;
  role?: ProjectInvitationToRoleResolver<TParent>;
  status?: ProjectInvitationToStatusResolver<TParent>;
}

export interface ProjectInvitationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectInvitationToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectInvitationToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectInvitationToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLProjectListTypeResolver<TParent = any> {
  total?: ProjectListToTotalResolver<TParent>;
  skip?: ProjectListToSkipResolver<TParent>;
  limit?: ProjectListToLimitResolver<TParent>;
  items?: ProjectListToItemsResolver<TParent>;
}

export interface ProjectListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ProjectListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLQueryTypeResolver<TParent = any> {
  status?: QueryToStatusResolver<TParent>;
  countries?: QueryToCountriesResolver<TParent>;
  timezones?: QueryToTimezonesResolver<TParent>;
  me?: QueryToMeResolver<TParent>;
  permissions?: QueryToPermissionsResolver<TParent>;
  workspaces?: QueryToWorkspacesResolver<TParent>;
  workspace?: QueryToWorkspaceResolver<TParent>;
  companies?: QueryToCompaniesResolver<TParent>;
  company?: QueryToCompanyResolver<TParent>;
  profiles?: QueryToProfilesResolver<TParent>;
  profile?: QueryToProfileResolver<TParent>;
  projects?: QueryToProjectsResolver<TParent>;
  project?: QueryToProjectResolver<TParent>;
  projectFiles?: QueryToProjectFilesResolver<TParent>;
  projectMembers?: QueryToProjectMembersResolver<TParent>;
  thread?: QueryToThreadResolver<TParent>;
  threadFiles?: QueryToThreadFilesResolver<TParent>;
  threadFilesWithOriginOrder?: QueryToThreadFilesWithOriginOrderResolver<TParent>;
  files?: QueryToFilesResolver<TParent>;
  file?: QueryToFileResolver<TParent>;
  fileVersion?: QueryToFileVersionResolver<TParent>;
  markerGroup?: QueryToMarkerGroupResolver<TParent>;
  activities?: QueryToActivitiesResolver<TParent>;
  invitationStatus?: QueryToInvitationStatusResolver<TParent>;
}

export interface QueryToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCountriesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTimezonesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPermissionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToWorkspacesArgs {
  limit?: number;
  skip?: number;
}
export interface QueryToWorkspacesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToWorkspacesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToWorkspaceArgs {
  id: string;
}
export interface QueryToWorkspaceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToWorkspaceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCompaniesArgs {
  limit?: number;
  skip?: number;
}
export interface QueryToCompaniesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCompaniesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCompanyArgs {
  id: string;
}
export interface QueryToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProfilesArgs {
  limit?: number;
  skip?: number;
}
export interface QueryToProfilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProfilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProfileArgs {
  id: string;
}
export interface QueryToProfileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProfileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProjectsArgs {
  limit?: number;
  skip?: number;
  searchQuery?: string;
}
export interface QueryToProjectsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProjectsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProjectArgs {
  id: string;
}
export interface QueryToProjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProjectArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProjectFilesArgs {
  id: string;
  status?: GQLFileStatusEnum;
  useTools?: boolean;
  unviewedOnly?: boolean;
  searchQuery?: string;
  dateRange?: GQLDateRange;
  types?: Array<GQLFileTypeEnum>;
}
export interface QueryToProjectFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProjectFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToProjectMembersArgs {
  id: string;
}
export interface QueryToProjectMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToProjectMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToThreadArgs {
  id: string;
}
export interface QueryToThreadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToThreadArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToThreadFilesArgs {
  id: string;
  status?: GQLFileStatusEnum;
  useTools?: boolean;
  unviewedOnly?: boolean;
  searchQuery?: string;
  dateRange?: GQLDateRange;
  types?: Array<GQLFileTypeEnum>;
}
export interface QueryToThreadFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToThreadFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToThreadFilesWithOriginOrderArgs {
  id: string;
}
export interface QueryToThreadFilesWithOriginOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToThreadFilesWithOriginOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFilesArgs {
  status?: GQLFileStatusEnum;
  useTools?: boolean;
  unviewedOnly?: boolean;
  limit?: number;
  skip?: number;
  ids?: Array<string>;
  searchQuery?: string;
  dateRange?: GQLDateRange;
  types?: Array<GQLFileTypeEnum>;
}
export interface QueryToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFileArgs {
  id: string;
}
export interface QueryToFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToFileVersionArgs {
  id: string;
}
export interface QueryToFileVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToFileVersionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMarkerGroupArgs {
  id: string;
}
export interface QueryToMarkerGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToMarkerGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToActivitiesArgs {
  projectId?: string;
  limit?: number;
  skip?: number;
  unreadOnly?: boolean;
}
export interface QueryToActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToActivitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInvitationStatusArgs {
  hash: string;
}
export interface QueryToInvitationStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInvitationStatusArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemoveCompanyProfilePayloadTypeResolver<TParent = any> {
  company?: RemoveCompanyProfilePayloadToCompanyResolver<TParent>;
}

export interface RemoveCompanyProfilePayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRemovePayloadTypeResolver<TParent = any> {
  id?: RemovePayloadToIdResolver<TParent>;
  success?: RemovePayloadToSuccessResolver<TParent>;
}

export interface RemovePayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RemovePayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLResolveMarkerPayloadTypeResolver<TParent = any> {
  marker?: ResolveMarkerPayloadToMarkerResolver<TParent>;
}

export interface ResolveMarkerPayloadToMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLThreadTypeResolver<TParent = any> {
  id?: ThreadToIdResolver<TParent>;
  title?: ThreadToTitleResolver<TParent>;
  serialNumber?: ThreadToSerialNumberResolver<TParent>;
  body?: ThreadToBodyResolver<TParent>;
  status?: ThreadToStatusResolver<TParent>;
  accessLevel?: ThreadToAccessLevelResolver<TParent>;
  isViewed?: ThreadToIsViewedResolver<TParent>;
  author?: ThreadToAuthorResolver<TParent>;
  approvedBy?: ThreadToApprovedByResolver<TParent>;
  contributors?: ThreadToContributorsResolver<TParent>;
  subscribers?: ThreadToSubscribersResolver<TParent>;
  messages?: ThreadToMessagesResolver<TParent>;
  files?: ThreadToFilesResolver<TParent>;
  ownFiles?: ThreadToOwnFilesResolver<TParent>;
  canEdit?: ThreadToCanEditResolver<TParent>;
  canRemove?: ThreadToCanRemoveResolver<TParent>;
  canApprove?: ThreadToCanApproveResolver<TParent>;
  canDisapprove?: ThreadToCanDisapproveResolver<TParent>;
  canCreateMessage?: ThreadToCanCreateMessageResolver<TParent>;
  canAddFile?: ThreadToCanAddFileResolver<TParent>;
  createdAt?: ThreadToCreatedAtResolver<TParent>;
  updatedAt?: ThreadToUpdatedAtResolver<TParent>;
}

export interface ThreadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToSerialNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToBodyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToAccessLevelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToIsViewedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToApprovedByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToContributorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToSubscribersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToMessagesArgs {
  limit?: number;
  skip?: number;
}
export interface ThreadToMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ThreadToMessagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToFilesArgs {
  limit?: number;
  skip?: number;
}
export interface ThreadToFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ThreadToFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToOwnFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCanEditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCanRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCanApproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCanDisapproveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCanCreateMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCanAddFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLThreadListTypeResolver<TParent = any> {
  total?: ThreadListToTotalResolver<TParent>;
  skip?: ThreadListToSkipResolver<TParent>;
  limit?: ThreadListToLimitResolver<TParent>;
  items?: ThreadListToItemsResolver<TParent>;
}

export interface ThreadListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ThreadListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTimezoneTypeResolver<TParent = any> {
  code?: TimezoneToCodeResolver<TParent>;
  name?: TimezoneToNameResolver<TParent>;
}

export interface TimezoneToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TimezoneToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTokensPayloadTypeResolver<TParent = any> {
  token?: TokensPayloadToTokenResolver<TParent>;
  refreshToken?: TokensPayloadToRefreshTokenResolver<TParent>;
  refreshTokenExpiration?: TokensPayloadToRefreshTokenExpirationResolver<TParent>;
}

export interface TokensPayloadToTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TokensPayloadToRefreshTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TokensPayloadToRefreshTokenExpirationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUnresolveMarkerPayloadTypeResolver<TParent = any> {
  marker?: UnresolveMarkerPayloadToMarkerResolver<TParent>;
}

export interface UnresolveMarkerPayloadToMarkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateMePayloadTypeResolver<TParent = any> {
  me?: UpdateMePayloadToMeResolver<TParent>;
}

export interface UpdateMePayloadToMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePasswordPayloadTypeResolver<TParent = any> {
  me?: UpdatePasswordPayloadToMeResolver<TParent>;
}

export interface UpdatePasswordPayloadToMeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWorkspaceTypeResolver<TParent = any> {
  id?: WorkspaceToIdResolver<TParent>;
  name?: WorkspaceToNameResolver<TParent>;
  companies?: WorkspaceToCompaniesResolver<TParent>;
  profiles?: WorkspaceToProfilesResolver<TParent>;
}

export interface WorkspaceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WorkspaceToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WorkspaceToCompaniesArgs {
  limit?: number;
  skip?: number;
}
export interface WorkspaceToCompaniesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: WorkspaceToCompaniesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WorkspaceToProfilesArgs {
  limit?: number;
  skip?: number;
}
export interface WorkspaceToProfilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: WorkspaceToProfilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWorkspaceListTypeResolver<TParent = any> {
  total?: WorkspaceListToTotalResolver<TParent>;
  skip?: WorkspaceListToSkipResolver<TParent>;
  limit?: WorkspaceListToLimitResolver<TParent>;
  items?: WorkspaceListToItemsResolver<TParent>;
}

export interface WorkspaceListToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WorkspaceListToSkipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WorkspaceListToLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface WorkspaceListToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}
